<template>
  <div :style="{width: width, height: height}" id="chart" ref="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      required: true,
      type: Array,
    },
    color: {
      type: String,
      default: '#46ccd9',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '120px',
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4Charts',
      'am4core',
    ]),
  },
  methods: {
    loaded() {
      setTimeout(() => {
        this.$emit('update-internal-step');
      }, 700);
    },
    generateGraphics() {
      this.chart = this.am4core.create(this.$refs.chart, this.am4Charts.PieChart);
      this.chart.data = this.data;
      this.chart.x = this.am4core.percent(-5);
      this.chart.width = this.am4core.percent(60);
      this.chart.numberFormatter.decimalSeparator = ',';
      this.chart.numberFormatter.thousandsSeparator = '.';
      this.chart.numberFormatter.numberFormat = '#,###.##';
      const series = this.chart.series.push(new this.am4Charts.PieSeries());
      this.chart.events.on('ready', () => this.loaded());
      series.dataFields.value = 'value';
      series.dataFields.category = 'name';
      series.ticks.template.disabled = true;
      series.slices.template.strokeWidth = 2;
      series.labels.template.disabled = true;
      series.slices.template.strokeOpacity = 1;
      series.hiddenState.properties.opacity = 1;
      series.hiddenState.properties.endAngle = -90;
      series.hiddenState.properties.startAngle = -90;
      series.slices.template.stroke = this.am4core.color('#fff');
      series.horizontalCenter = true;
      series.colors.list = [
        this.am4core.color(this.color),
        this.am4core.color('#d6dadd'),
      ];
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  width: 80%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/Pie.vue